import { render, staticRenderFns } from "./ordstatisticsdatatime_warehousing.vue?vue&type=template&id=06dab793&scoped=true&"
import script from "./ordstatisticsdatatime_warehousing.vue?vue&type=script&lang=ts&"
export * from "./ordstatisticsdatatime_warehousing.vue?vue&type=script&lang=ts&"
import style0 from "./ordstatisticsdatatime_warehousing.vue?vue&type=style&index=0&id=06dab793&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dab793",
  null
  
)

component.options.__file = "ordstatisticsdatatime_warehousing.vue"
export default component.exports